import React, { useState } from "react";
import { Instagram, MessageCircle, Plus } from "lucide-react";
import { COMPANY } from "../lib/siteData";

const TikTokIcon = ({ size = 18 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
    >
        <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
    </svg>
);

export const FloatingContact = () => {
    const [open, setOpen] = useState(false);

    const items = [
        {
            href: COMPANY.whatsapp,
            label: "WhatsApp",
            icon: (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                    <path d="M20.5 3.5A11 11 0 0 0 3.6 17.9L2 22l4.2-1.6A11 11 0 1 0 20.5 3.5Zm-8.5 18a9.5 9.5 0 0 1-4.8-1.3l-.3-.2-2.5.9.8-2.4-.2-.3A9.5 9.5 0 1 1 12 21.5Zm5.4-6.9c-.3-.2-1.7-.9-2-1s-.5-.2-.7.2-.8 1-1 1.2-.4.2-.7 0a7.7 7.7 0 0 1-2.3-1.4 8.5 8.5 0 0 1-1.6-2c-.2-.3 0-.5.1-.7l.4-.5c.2-.2.2-.3.3-.5s0-.4 0-.5-.7-1.6-.9-2.2-.5-.5-.7-.5H8c-.2 0-.5 0-.8.3a3 3 0 0 0-1 2.4c0 1.4 1 2.8 1.2 3s2.1 3.2 5.2 4.5c.7.3 1.3.5 1.8.6.8.2 1.4.2 2 .1.6-.1 1.7-.7 2-1.4s.3-1.3.2-1.4-.3-.2-.6-.3Z" />
                </svg>
            ),
            bg: "bg-[#25D366]",
            text: "text-white",
            testId: "float-whatsapp",
        },
        {
            href: COMPANY.instagram,
            label: "Instagram",
            icon: <Instagram size={20} strokeWidth={1.6} />,
            bg: "bg-hhc-ink",
            text: "text-hhc-ivory",
            testId: "float-instagram",
        },
        {
            href: COMPANY.tiktok,
            label: "TikTok",
            icon: <TikTokIcon size={20} />,
            bg: "bg-hhc-ivory border border-hhc-line",
            text: "text-hhc-ink",
            testId: "float-tiktok",
        },
    ];

    return (
        <div
            className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3"
            data-testid="floating-contact"
        >
            {open &&
                items.map((it, i) => (
                    <a
                        key={it.label}
                        href={it.href}
                        target="_blank"
                        rel="noreferrer"
                        data-testid={it.testId}
                        className={`${it.bg} ${it.text} w-12 h-12 rounded-full grid place-items-center shadow-[0_15px_30px_-10px_rgba(31,35,33,0.35)] hover:scale-105 transition-transform fade-up`}
                        style={{ animationDelay: `${i * 60}ms` }}
                        aria-label={it.label}
                    >
                        {it.icon}
                    </a>
                ))}

            <button
                type="button"
                onMouseEnter={() => setOpen(true)}
                onFocus={() => setOpen(true)}
                onClick={() => setOpen((v) => !v)}
                data-testid="float-main-button"
                aria-expanded={open}
                aria-label={open ? "Close contact options" : "Open contact options"}
                className="group relative w-14 h-14 rounded-full bg-hhc-clay text-white grid place-items-center shadow-[0_20px_40px_-10px_rgba(193,119,103,0.6)] hover:bg-hhc-clayDeep transition-colors"
            >
                {!open && (
                    <span className="absolute inset-0 rounded-full animate-ping bg-hhc-clay/40" />
                )}
                <span
                    className={`relative transition-transform duration-300 ${
                        open ? "rotate-45" : ""
                    }`}
                    data-testid="float-toggle"
                >
                    {open ? (
                        <Plus size={22} strokeWidth={1.75} />
                    ) : (
                        <MessageCircle size={22} strokeWidth={1.75} />
                    )}
                </span>
            </button>
        </div>
    );
};

export default FloatingContact;
